import { adaptEodGate, type EodGate, type EodGateApi } from '@tempmee/awards';
import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { AWARDS_API_PREFIX } from './awardsApiBase';

/**
 * Fetch the CS-5 EOD gate for a `(cycle, applicant)` pair — whether the
 * authenticated reviewer (the office) should be prompted about that applicant.
 * `GET /cycles/{cycleId}/feedback/{applicantUserId}`. Maps the wire shape
 * through `adaptEodGate` (`pending` → `showStep`).
 *
 * The response does NOT carry the applicant's name — the caller supplies it
 * from the shift for `{NAME}` substitution.
 *
 * This client does NOT catch errors — callers MUST go through
 * `services/GetEodBidGate.ts`, which fails open to `CLOSED_EOD_GATE` on any
 * error. The EOD flow must never block on this call.
 *
 * `officeId` overrides the `x-office` header: the gate answer depends on WHO
 * is asking, and a pending-list row must be asked as the ROW's office — for
 * a multi-office admin that is not the selected office.
 */
export const getEodBidGate = async (
  cycleId: string,
  applicantUserId: string,
  officeId?: string,
): Promise<EodGate> => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.get<EodGateApi>(
    `${AWARDS_API_PREFIX}/cycles/${cycleId}/feedback/${applicantUserId}`,
    { headers: officeId ? { ...headers, 'x-office': officeId } : headers },
  );
  return adaptEodGate(response.data);
};
